import { Request } from 'commons/utils/request'
import { Layer, Page, PageFace } from 'ui/components'
import { ExportCSVButton } from 'ui/temp/ExportCSVButton'

import { ReportBreadcrumbs } from '../../components'
import { AlertsTable } from './components'
import { AlertsReportContextProvider } from './context/contextProvider'

const AlertsReport = () => (
  <AlertsReportContextProvider>
    <Page
      face={PageFace.PRIMARY}
      title={<ReportBreadcrumbs title="Alerts Report" />}
      actions={<ExportCSVButton reportName="Alerts" url={Request.urls.bank.portalReportAlertsCSV} />}
    >
      <Layer rounded shadowed stretch>
        <AlertsTable />
      </Layer>
    </Page>
  </AlertsReportContextProvider>
)

export default AlertsReport
